import React from "react";
import { useTranslation } from "react-i18next";
import TopBar from "../../components/TopBar";
import Footer from "../../components/Footer";
import Product from "../../components/home/Product";
import More from "../about/components/more";
import { useNavigate } from "react-router";

const ComponentName: React.FC = () => {
  const { t } = useTranslation();
  const [see, setSee] = React.useState(false)
  const navigate = useNavigate()
  return (
    <div className="">
      <TopBar />
      <div className=" w-[1200px] mx-auto h5:w-full">
        <div className="my-[30px] flex items-center text-[#181512] text-[16px] h5:px-16">
          <div className="text-[#595959] text-[16px] mr-4 cursor-pointer" onClick={() => navigate('/')}>首頁</div>
          /
          <div className="text-[#181512] text-[16px] ml-4">隱私權政策</div>
        </div>
        <br />

        <div className="text-[#181512] text-[44px] font-bold text-center h5:px-16">隱私權保護政策</div>
        <br />
        <div className="h5:px-16">
          <div className="text-[#595959] text-[16px] mb-[30px]">歡迎您使用詩肯股份有限公司(以下簡稱本公司)網站(以下簡稱本網站)，為了保障顧客權益，並能夠安心使用本公司網站提供之各項服務，在此向您說明本公司網站之隱私權保護政策，及相關資料保護之措施。</div>
          <div className="text-[#595959] text-[16px] mb-[30px]">
            一、隱私權保護政策的適用範圍
            <br /><br />
            隱私權保護政策內容，包括本網站如何處理及利用在您使用網站服務時所蒐集之個人識別資料。隱私權保護政策不適用於本網站以外的相關連結網站，且不適用於非本網站所委託或參與管理的人員。
            <br /><br />
            二、個人資料蒐集、處理及利用方式
            <br /><br />
            ◎當您造訪本網站或使用本網站所提供之功能服務時，我們將視該服務功能性 質，請您提供必要的個人資料，本公司蒐集個人資料之特定目的包含：040行銷、067信用卡業務、069契約、類似契約或其他法律關係事務、090消費者管理與服務、157調查、統計與研究分析，是作為與您聯繫、通知各類活動、行銷資訊、贈獎活動、提供商品與服務，或開發分析新商品服務等用途，並在完成該服務功能所需之特定目的範圍內處理及利用您的個人資料，包括：您的姓名、聯絡電話、通訊地址、電子郵件信箱、付款資訊及其他由您主動提供之資料等，非經您同意，本網站不會將個人資料提供予任何與本公司服務或前開特定目的無關之第三人，或移作其他目的使用。
            <br /><br />
            ◎個人資料利用之方式：
            <br /><br />
            (1)本網站在您使用服務信箱、問卷調查等互動性功能時，亦會保留您所提供 的姓名、電子郵件地址、聯絡方式及使用時間等資料。
            <br /><br />
            (2)於一般瀏覽時，伺服器會自行記錄相關行徑，包括您使用連線設備的IP位址、使用時間、使用的瀏覽器、瀏覽及點選資料記錄等，做為本公司增進本網站服務的參考依據，此記錄為本公司內部應用，決不對外公佈。
            <br /><br />
            (3)為提供精確的服務，本公司會將收集的問卷調查內容進行統計與分析，分析結果之統計數據或說明文字呈現，除供內部研究外，我們會視需要公佈統計數據及說明文字，但不涉及特定個人之資料。
            <br /><br />
            ◎個人資料利用之期間：本公司營運期間及依法令或契約規範應保存個人資料之期間。
            <br /><br />
            ◎個人資料利用之地區：中華民國境內。
            <br /><br />
            ◎關於您所提供的個人資料，可以行使下列權利：
            <br /><br />
            (1)查詢或請求閱覽
            <br /><br />
            (2)請求製給複製本
            <br /><br />
            (3)請求補充或更正
            <br /><br />
            (4)請求停止蒐集、處理或利用
            <br /><br />
            (5)請求刪除。
            <br /><br />
            其個人資料，惟應提出適當之證明文件且本公司依法得酌收必要的成本費用。為保障消費者個人資料安全，行使前揭權利時，可洽本公司各門市辦理、直撥客服電話：0800-358088，或寄送電子郵件至客服信箱：hello@scanteak.com.tw 聯絡申請。相關申請資料提供之方式、處理期限、查詢費用等事項，均依法令及本公司之相關規定辦理。
            <br /><br />
            ◎您可自由決定是否提供個人資料予本公司，而如您不予提供，或是後續請求刪除或停止蒐集、處理或利用時，可能會導致您無法使用本網站之全部或部分服務與功能。
            <br /><br />
            ◎個人資料利用之對象：包括本公司、本公司委託處理事務之單位或個人、依法令有權利用之機構或其他經您個別同意之對象。
            <br /><br />
            三、資料之保護
            <br /><br />
            ◎本網站主機均設有防火牆、防毒系統等相關的各項資訊安全設備及必要的安全防護措施，採用嚴格的保護措施加以保護網站及您的個人資料，只有經過授權的人員才能接觸您的個人資料，相關處理人員皆簽有保密合約，如有違反保密義務者，將會受到相關的法律處分。
            <br /><br />
            ◎如因業務需要有必要委託其他單位提供服務時，本網站亦會嚴格要求其遵守保密義務，並且採取必要檢查程序以確定其將確實遵守。
            <br /><br />
            四、網站對外的相關連結
            <br /><br />
            本網站的網頁提供其他網站的網路連結，您也可經由本網站所提供的連結，點選進入其他網站。但該連結網站不適用本網站的隱私權保護政策，您必須參考該連結網站中的隱私權保護政策。
            <br /><br />
            五、與第三人共用個人資料之政策
            <br /><br />
            本網站絕不會違法提供、交換、出租或出售任何您的個人資料給其他個人、團體、私人企業或公務機關，但有法律依據或合約義務者，不在此限。
            <br /><br />
            前項但書之情形包括不限於：
            <br /><br />
            (1)經由您書面同意。
            <br /><br />
            (2)法律明文規定。
            <br /><br />
            (3)為免除您生命、身體、自由或財產上之危險。
            <br /><br />
            (4)與公務機關或學術研究機構合作，基於公共利益為統計或學術研究而有必要，且資料經過提供者處理後或蒐集者依其揭露方式無從再識別特定之個人。
            <br /><br />
            (5)當您在網站的行為，違反服務條款或可能損害或妨礙網站與其他使用者權益或導致任何人遭受損害時，而本網站管理單位研析揭露您的個人資料是為了辨識、聯絡或採取法律行動所必要者。
            <br /><br />
            (6)有利於您的權益。
            <br /><br />
            (7)為達成蒐集、處理或利用之目的，本網站委託廠商協助蒐集、處理或利用您的個人資料時。但本公司將對委外廠商或個人善盡監督管理之責。
            <br /><br />
            六、Cookie之使用
            <br /><br />
            為了提供您最佳的服務，本網站會在您的電腦中放置並取用我們的 Cookie，若您不願接受 Cookie 的寫入，您可在您使用的瀏覽器功能項中設定隱私權等級為高，即可拒絕 Cookie 的寫入，但可能會導致網站某些功能無法正常執行。
            <br /><br />
            七、隱私權保護政策之修正
            <br /><br />
            本聲明將因應相關法規修訂、本網站或其他環境變遷因素，由本公司隨時進行修正，修正後的條款將更新於本網站上以告知消費者相關事項。
            <br /><br /> <br /><br /> <br /><br />
          </div>
        </div>


      </div>

      <Footer />
    </div>
  );
};

export default ComponentName;
